import { Typography } from 'antd';
import type { ReactNode } from 'react';
import styles from './PageHeader.module.scss';

const { Title } = Typography;

type Props = {
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  level?: 2 | 3 | 4;
  // A gradient tile beside the title, matching the app icons on the home page. Also switches the title to
  // the larger, bolder style that goes with it.
  icon?: ReactNode;
  iconTone?: 'ideas' | 'praises' | 'feedback';
};

export const PageHeader = ({ title, subtitle, action, level = 3, icon, iconTone = 'ideas' }: Props) => {
  return (
    <div className={styles.header}>
      <div className={styles.lead}>
        {icon ? (
          <span className={`${styles.icon} ${styles[iconTone]}`} aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <div className={styles.copy}>
          <Title level={level} className={icon ? `${styles.title} ${styles.prominent}` : styles.title}>
            {title}
          </Title>
          {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
        </div>
      </div>
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
};
